import SignUpBySignUpCodeView from '@/views/SignUpBySignUpCodeView';

/**
 * This page necessary, because we have situation where no signUpcode given
 *
 * TODO: Delete this page if all sign-up with signUpCode or trackId
 */
export default function SignUp() {
  return <SignUpBySignUpCodeView />;
}
